export default "__VITE_ASSET__nTLMwbaK__"